import { render, staticRenderFns } from "./GameBoardLetter.vue?vue&type=template&id=985308c2&scoped=true&"
import script from "./GameBoardLetter.vue?vue&type=script&lang=ts&"
export * from "./GameBoardLetter.vue?vue&type=script&lang=ts&"
import style0 from "./GameBoardLetter.vue?vue&type=style&index=0&id=985308c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985308c2",
  null
  
)

component.options.__file = "GameBoardLetter.vue"
export default component.exports